import React from 'react';
import LegalDocument from '../components/LegalDocument';

const TermsPage = () => <LegalDocument ns="terms" />;

export default TermsPage;
